import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  IonCheckbox,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonRow,
  IonSelect,
  IonSelectOption,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { CountryStateService } from '@okcargo-apps/shared-infrastructure-ionic';
import { CompanyRegistrationCompanyFormModel } from '../company-registration-forms.model';

@Component({
  selector: 'lib-company-registration-form',
  templateUrl: './company-registration-form.component.html',
  styleUrls: ['./company-registration-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonCheckbox,
    IonItem,
    IonItemGroup,
    IonItemDivider,
    IonIcon,
    TranslateModule,
  ],
})
export class CompanyRegistrationFormComponent {
  private readonly countryStateService = inject(CountryStateService);

  public form = input.required<FormGroup<CompanyRegistrationCompanyFormModel>>();

  public countries = this.countryStateService.countries;

  public getErrorMessage(controlName: keyof CompanyRegistrationCompanyFormModel): string | null {
    const control = this.form().controls[controlName];
    if (!control || !control.errors) {
      return null;
    }

    const firstErrorKey = Object.keys(control.errors)[0];
    const errorData = control.errors[firstErrorKey];

    if (typeof errorData === 'string') {
      return errorData;
    }
    return errorData?.message || 'error.mandatory';
  }
}
